module.exports = __webpack_public_path__ + "static/media/NewHeaderLogo.fc110205.png";